export default __webpack_public_path__ + "static/Figtree-Light-2e3ffc02ed93e52feb245689913dcac0.woff";